export const getDomain = (market) => {
    if (market !== 'en') {
        if (market === 'sk' || market === 'cz') {
            // TODO:: Odstranit
            return `goodeshop.${market}`;
        }

        return `fynode.${market}`;
    }

    return 'fynode.com';
};
